var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import useDesign from '../../../../../hooks/useDesign';
import { BaseButton } from '../../../../atoms/BaseButton';
import { Icon } from '../../../../atoms/Icon';
import { TranslatedText } from '../../../../atoms/TranslatedText/TranslatedText';
export var SelectButton = function (_a) {
    var design = _a.design, _b = _a.selectedOption, selectedOption = _b === void 0 ? {} : _b, placeholder = _a.placeholder, props = __rest(_a, ["design", "selectedOption", "placeholder"]);
    var _c = useDesign(design), components = _c.components, schema = _c.schema, config = _c.config;
    var i18n = selectedOption.i18n;
    var icon = useDesign(components === null || components === void 0 ? void 0 : components.icon);
    var typography = useDesign(components === null || components === void 0 ? void 0 : components.typography);
    return (_jsxs(BaseButton, __assign({ "data-design": design, typography: typography.schema, icon: icon.schema, schema: schema, hasSelected: !!i18n }, props, { children: [i18n ? (_jsx(TranslatedText, __assign({ textAlign: "left", i18n: i18n }, typography.config))) : (_jsx(TranslatedText, __assign({ textAlign: "left", i18n: (config === null || config === void 0 ? void 0 : config.placeholder) || placeholder }, typography.config))), _jsx(Icon, { design: components === null || components === void 0 ? void 0 : components.icon })] })));
};
SelectButton.displayName = 'SelectButton';
